<template>
  <div>
    <div>
      <el-radio-group v-model="radio" size="small" @change="handleClickradio" style="background: #fff;width: 100%;">
        <el-radio-button label="1">卷板</el-radio-button>
        <el-radio-button label="2">建材</el-radio-button>
      </el-radio-group>
      <div v-show="radio == 1">
        <div class="formBox margbot" ref="searchBoxJB">
          <el-form :inline="true" :model="formDataJB" label-width="95px" size="mini" style="width: 100%;">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select size="mini" filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple
                style="width: 280px">
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                  :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="捆包编号:">
              <el-input  v-model="gangJuanNum"
                size="mini" placeholder="可支持多个" type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="出库日期：">
              <div style="display: flex;">
              <el-date-picker v-model="formDataJB.outstockDateStart" size="mini" type="datetime" placeholder="选择出库日期"
                value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              -
              <el-date-picker v-model="formDataJB.outstockDateEnd" size="mini" placeholder="选择出库日期" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="合同编号:">
              <el-input class="ipt" v-model="formDataJB.contractNumber" placeholder="请输入合同号" size="mini"
                ></el-input>
            </el-form-item>
            <el-form-item label="出库车牌号:">
              <el-input class="ipt" v-model="formDataJB.outstockPlateNumber" placeholder="请输入出库车牌号" size="mini"
                ></el-input>
            </el-form-item>
            <el-form-item label="出库单编号:">
              <el-input class="ipt" v-model="formDataJB.outstockNo" placeholder="请输入出库单编号" size="mini"
                ></el-input>
            </el-form-item>
            <el-form-item label="规格:">
              <el-input v-model="formDataJB.specification" size="mini" placeholder="请输入规格" >
              </el-input>
            </el-form-item>
            <el-form-item label="出库客户：">
              <el-input v-model="formDataJB.outCustomerName" size="mini" placeholder="请输入出库客户" >
              </el-input>
            </el-form-item>
            <el-form-item label="出库司机：">
              <el-input v-model="formDataJB.outDriverName" size="mini" placeholder="请输入出库司机" >
              </el-input>
            </el-form-item>
            <el-form-item label="客户名称:">
              <el-input v-model="formDataJB.customerName" size="mini" placeholder="请输入客户名称" >
              </el-input>
            </el-form-item>
            <el-form-item label="合约编号：">
              <el-input v-model="formDataJB.agreementNumber" size="mini" placeholder="请输入合约号" >
              </el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select size="mini" v-model="formDataJB.productType" placeholder="请选择货物类型" filterable clearable
                >
                <el-option v-for="item in typeData" :label="item.show_name" :key="item.show_name" :value="item.item_no">
                </el-option>
              </el-select>
            </el-form-item>
           </div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxunJB" btnCode="00ZP00CB00D" v-if="btnFlg[12]">查询
              </el-button>
              <el-button type="primary" size="mini" @click="chongzhiJB" btnCode="00ZP00CB00E" v-if="btnFlg[13]">重置
              </el-button>
              <el-button type="primary" size="mini" @click="daochuJB" btnCode="00ZP00CB00F" v-if="btnFlg[14]">导出
              </el-button>
              <el-button type="primary" size="mini" @click="MBdaochuJB" btnCode="00ZM0S0100"
                v-if="btnFlg[34]">模板导出</el-button>
              <span style="margin-left:10px">总吨数：<span style="color:red">{{ Number(allWeightJB) }}</span> 吨</span>
              <span style="margin-left:10px">总件数：<span style="color:red">{{ allNumberJB }}</span> 件</span>
            </el-form-item>
          </el-form>
        </div>
        <div :style="{ height: h }">
          <el-table border center bordersize="mini" :data="tableDataJB" class="tableComent" height="100%" style="width:100%" size="mini"
            highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
              width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center" width="230">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
              width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库名" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位名" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位名" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单编号" align="center" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库日期" align="center" width="180"
              :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="出库车牌号" align="center"
              width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outDriverName" label="出库司机" align="center" width="130">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center" width="150">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="stockDays" label="库存天数" align="center" width="100">
            </el-table-column>
          </el-table>
        </div>
        <div class="pags">
          <el-pagination background @current-change="handleCurrentChangeJB" :current-page="pageInfoJB.pageNo"
            :page-size="pageInfoJB.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJB" :total="totalJB">
          </el-pagination>
        </div>
      </div>
      <!-- 建材 -->
      <div v-show="radio == 2">
        <div class="formBox margbot" ref="searchBoxJC">
          <el-form :inline="true" :model="formDataJC" label-width="95px" size="mini" style="width: 100%;">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select size="mini" filterable clearable placeholder="请选择" v-model="CKName" multiple @change="clickCK()"
               >
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                  :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库单号:">
              <el-input class="ipt" v-model="formDataJC.outstockNo" placeholder="请输入出库单号" size="mini"
                ></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-input v-model="formDataJC.primaryCustomerName" size="mini" placeholder="请输入一级货主" >
              </el-input>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-input v-model="formDataJC.customerName" size="mini" placeholder="请输入二级货主" >
              </el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="formDataJC.productType" clearable placeholder="请选择" filterable size="mini"
                >
                <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                  :value="item.productType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="formDataJC.placeOfOrigin" clearable placeholder="请选择" filterable size="mini"
                >
                <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格:">
              <el-select v-model="formDataJC.specification" clearable placeholder="请选择" filterable size="mini"
                >
                <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质:">
              <el-select v-model="formDataJC.model" clearable placeholder="请选择" filterable size="mini"
                >
                <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库时间:">
              <div style="display: flex;">
              <el-date-picker v-model="formDataJC.outstockDateStart" size="mini" type="datetime" placeholder="选择出库时间"
                value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              -
              <el-date-picker v-model="formDataJC.outstockDateEnd" size="mini" placeholder="选择出库时间" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="客户单号:">
              <el-input class="ipt" v-model="formDataJC.outBillNo" placeholder="请输入客户单号" size="mini"
                ></el-input>
            </el-form-item>
            <el-form-item label="提货单号:">
              <el-input class="ipt" v-model="formDataJC.billNo" placeholder="请输入提货单号" size="mini" >
              </el-input>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input class="ipt" v-model="formDataJC.outstockPlateNumber" placeholder="请输入车号" size="mini"
                ></el-input>
            </el-form-item>
            </div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxunJC" btnCode="00ZP00CB00G" v-if="btnFlg[15]">查询
              </el-button>
              <el-button type="primary" size="mini" @click="chongzhiJC" btnCode="00ZP00CB00H" v-if="btnFlg[16]">重置
              </el-button>
              <el-button type="primary" size="mini" @click="daochuJC" btnCode="00ZP00CB00I" v-if="btnFlg[17]">导出
              </el-button>
              <el-button type="primary" size="mini" @click="MBdaochuJC" btnCode="00ZM0S0200"
                v-if="btnFlg[35]">模板导出</el-button>
              <span style="margin-left:10px">总吨数：<span style="color:red">{{ Number(allWeightJC) }}</span> 吨</span>
              <span style="margin-left:10px">总件数：<span style="color:red">{{ allNumberJC }}</span> 件</span>
            </el-form-item>
          </el-form>
        </div>
        <div :style="{ height: H }">
          <el-table border center bordersize="mini"  class="tableComent" :data="tableDataJC" height="100%" style="width:100%" size="mini"
            highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            @row-click="handleRowClick">
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="客户单号" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库时间" width="180">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockUserName" label="出库人" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单号" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车号" width="200">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" width="180">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" width="180">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180"></el-table-column>
          </el-table>
        </div>
        <div class="pags">
          <el-pagination background @current-change="handleCurrentChangeJC" :current-page="pageInfoJC.pageNo"
            :page-size="pageInfoJC.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJC" :total="totalJC">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="请选择" :visible.sync="DialogVisible" :close-on-click-modal="false" width="40%" @close="BHQx" center>
      <div style="margin:20px auto 0">

        <div style="margin-top:10px;">
          <span style="display:inline-block;width:40%;text-align:right">导出客户：</span>
          <el-radio-group v-model="HZradio">
            <el-radio :label="1">一级货主</el-radio>
            <el-radio :label="2">二级货主</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BHQx">取 消</el-button>
        <el-button type="primary" @click="BHOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVirtualBalingList,
  getDictionaryAll,
  getOutExpList,
  getOutExpNumber,
  findUserTenantRelList,
  getOutStockCargoRecordList,
  exOutStockCargoRecordList,
  exOutExpList,
  getOutStockCargoRecordListAllWeight
} from '@/api/wms-stock'
import {
  zidian
} from '@/api/wms-access'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
export default {
  name: 'CKRecord',
  data () {
    return {
      DialogVisible: false,
      HZradio: 2,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      radio: 1,
      // 卷板
      total: 0,
      pageInfoJB: {
        pageNo: 1,
        pageSize: 20
      },
      formDataJB: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        model: '',
        billNo: '',
        outBillNo: '',
        agreementNumber: ''
      },
      tableDataJB: [],
      allWeightJB: 0,
      allNumberJB: 0,
      totalJB: 0,
      // 建材
      formDataJC: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerName: '',
        customerName: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        outBillNo: ''
      },
      pageInfoJC: {
        pageNo: 1,
        pageSize: 20
      },
      totalJC: 0,
      allWeightJC: 0,
      allNumberJC: 0,
      tableDataJC: [],
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      btnArr: [
        '00ZP00CB001',
        '00ZP00CB002',
        '00ZP00CB003',
        '00ZP00CB004',
        '00ZP00CB005',
        '00ZP00CB006',
        '00ZP00CB007',
        '00ZP00CB008',
        '00ZP00CB009',
        '00ZP00CB00A',
        '00ZP00CB00B',
        '00ZP00CB00C',
        '00ZP00CB00D',
        '00ZP00CB00E',
        '00ZP00CB00F',
        '00ZP00CB00G',
        '00ZP00CB00H',
        '00ZP00CB00I',
        '00ZP00CB00J',
        '00ZP00CB00K',
        '00ZP00CB00L',
        '00ZP00CB00M',
        '00ZP00CB00N',
        '00ZP00CB00O',
        '00ZP00CB00Q',
        '00ZP00CB00R',
        '00ZP00CB00S',
        '00ZP00CB00T',
        '00ZP00CB00U',
        '00ZP00CB00V',
        '00ZP00CB00W',
        '00ZP00CB00X',
        '00ZP00CB00Y',
        '00ZP00CB00Z',
        '00ZP00CB00a',
        '00ZM0S0100',
        '00ZM0S0200'
      ],
      btnFlg: [],
      h: 500,
      H: 500,
      xuanzhongArr: null,
      selectListId: [],
      selectList: [],
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      CKData: [],
      // 字典
      addKuwei: [],
      addQ: [],
      addH: [],
      typeId: '', // 冷热卷
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      typeName: '',
      typeData: [],
      CKName: [],
      gangJuanNum: ''
    }
  },
  props: {
    CKVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    BHOk () {
      let BHchange

      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exOutExpList({
        ...this.formDataJC,
        ...this.formData,
        organizationIds: this.CKName.join(','),
        instockStatus: '1',
        templateChange: BHchange,
        firstRequest: '1',
        exportCustomer: this.HZradio,
        organizationName: arr.join(',')
      })
        .then(res => {
          exportExcel(
            this.global.wmsStockName +
            '/recordDetails/exOutExpList',
            {
              ...this.formDataJC,
              ...this.formData,
              organizationIds: this.CKName.join(','),
              instockStatus: '1',
              templateChange: BHchange,
              exportCustomer: this.HZradio,
              organizationName: arr.join(',')
            },
            '出库记录信息表'
          )
          this.DialogVisible = false
          this.HZradio = 2
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    BHQx () {
      this.DialogVisible = false
      this.HZradio = 2
    },
    daochuJC () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportPutInStorageList',
        {
          ...this.formDataJC,
          ...this.formData,
          organizationIds: this.CKName.join(','),
          instockStatus: '1'
        },
        '入库记录信息表'
      )
    },
    MBdaochuJC () {
      console.log(this.CKName)
      if (!this.formDataJC.primaryCustomerName && !this.formDataJC.customerName) {
        DonMessage.error('请输入一级货主或二级货主')
        return
      }
      this.DialogVisible = true
    },
    MBdaochuJB () {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exOutStockCargoRecordList({
        ...this.formDataJB,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
        instockStatus: '1',
        firstRequest: '1',
        organizationName: arr.join(',')
      })
        .then(res => {
          console.log(res)
          exportExcel(
            this.global.wmsStockName +
            '/whInOutStockCargoRecord/exOutStockCargoRecordList',
            {
              ...this.formDataJB,
              organizationIds: this.CKName.join(','),
              cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
              instockStatus: '1',
              organizationName: arr.join(',')
            },
            '出库记录信息表'
          )
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
      // }
    },
    // 仓库改变
    clickCK () {
      this.getVirtualBalingList()
    },
    // 货物类型卷板
    zidianS () {
      getDictionaryAll({
        groupNo: 'product_type'
      })
        .then(res => {
          this.typeData = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList({
        userCode: window.localStorage.getItem('userCode'),
        tenantCode: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleClickradio () {
      if (this.radio == 1) {
        this.chongzhiJB()
      } else {
        this.chongzhiJC()
        let H = this.$refs.searchBoxJC.offsetHeight
        let pHJC = document.documentElement.clientHeight
        this.H = pHJC - H - 235 + 'px'
      }
    },
    // 卷板
    chaxunJB () {
      getOutStockCargoRecordList({
        ...this.formDataJB,
        ...this.pageInfoJB,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.tableDataJB = res.pageInfo.list
          this.totalJB = res.pageInfo.total
          getOutStockCargoRecordListAllWeight({
            ...this.formDataJB,
            ...this.pageInfoJB,
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
            organizationFlag: 1
          })
            .then(res => {
              console.log(res)
              this.allWeightJB = res.weight.allWeight
              this.allNumberJB = res.weight.allNumber
            })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhiJB () {
      this.pageInfoJB = {
        pageNo: 1,
        pageSize: 20
      }
      this.formDataJB = {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerTaxId: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        outBillNo: '',
        agreementNumber: ''
      }
      this.CKName = []
      this.gangJuanNum = ''
      this.chaxunJB()
    },
    daochuJB () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportOutCargoList', {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1'
        },
        '出库记录表'
      )
    },
    handleCurrentChangeJB (val) {
      this.pageInfoJB.pageNo = val
      this.chaxunJB()
    },
    handleSizeChangeJB (val) {
      this.pageInfoJB.pageSize = val
      this.chaxunJB()
    },
    // 建材
    chaxunJC () {
      this.getOutExpList()
    },
    chongzhiJC () {
      this.formDataJC = {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        primaryCustomerName: '',
        outstockPlateNumber: '',
        productType: '',
        placeOfOrigin: '',
        specification: '',
        outBillNo: '',
        customerName: ''
      }
      this.pageInfoJC = {
        pageNo: 1,
        pageSize: 20
      }
      this.CKName = []
      this.chaxunJC()
      this.getVirtualBalingList()
    },
    daochuJC () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportOutExpList', {
          ...this.formDataJC,
          organizationIds: this.CKName.join(','),
          instockStatus: '1'
        },
        '出库记录表'
      )
    },
    handleCurrentChangeJC (val) {
      this.pageInfoJC.pageNo = val
      this.chaxunJC()
    },
    handleSizeChangeJC (val) {
      this.pageInfoJC.pageSize = val
      this.chaxunJC()
    },
    // 列表查询
    getOutExpList () {
      getOutExpList({
        ...this.formDataJC,
        ...this.pageInfoJC,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          this.tableDataJC = res.list
          this.totalJC = res.total
          this.getOutExpNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总吨数总件数
    getOutExpNumber () {
      getOutExpNumber({
        ...this.formDataJC,
        ...this.pageInfoJC,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          // this.allWeightJC = res.totalAllWeight

          this.allWeightJC = parseFloat(res.totalAllWeight.toFixed(6))

          this.allNumberJC = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleRowClick (row) {
      this.xuanzhongArr = row
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList({
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }
  },
  created () {
    this.findUserTenantRelList()
    this.zidianS()
    this.chaxunJB()
    this.chaxunJC()
    this.btnFlg = getBtn(this.btnArr, '/ChuRuReport')
    this.getOutExpList()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBoxJB.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 235 + 'px'
  }
}

</script>

<style lang="less" scoped>
.inpBox1 {
  /deep/.el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}</style>
